// @flow

import React, { type Node } from 'react';
import { Body } from '../../../organisms/shared-styled-components';
import styled from 'styled-components';
import { MerchantLogo } from '../../../organisms/merchant-info';
import { PaymentDetails } from './payment-details';
import { ImportantToKnow } from './important-to-know';
import { translate } from '@tectonics/translate';

export function FawryPage(): Node {
  return (
    <>
      <Content>
        <MerchantLogo height="100px" />
        <Body>
          <Title>
            {translate('volcanes.opened-payment.fawry.title')}
          </Title>
          <PaymentDetails />
          <Divider />
          <ImportantToKnow />
        </Body>
      </Content>
    </>
  );
}

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 16px 32px 16px;
  font-family: ${props => props.theme.fontFamily.sansSerif};

  > * {
    width: 100%;
    margin: 16px auto 6px;
  }

  @media (min-width: 840px) {
    height: auto;
    padding: 0 0 16px 0;
  }
`;

const Title = styled.div`
  padding: 0 16px 32px 16px;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;

const Divider = styled.div`
  margin-top: 32px;
  border: 1px dashed rgb(220,225,230);
`;
